import styled from '@emotion/styled'

export const StyledMessageIcon = styled('svg')(() => ({
    flexShrink: 0,
    width: '16px',
    height: '16px',
    position: 'relative',
    overflow: 'visible',
    boxSizing: 'border-box',
    marginLeft: '2px',
    justifyItems: 'end',
}))
